import styled from '@emotion/styled';
import Avatar from 'presentations/views/components/atoms/Avatar';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import {
  blueGrayPale,
  gray02,
  primary,
} from 'presentations/views/styles/color';
import { SyntheticEvent } from 'react';
import { transformImageUrl } from 'presentations/assets';
import ProgressScreen from 'presentations/views/components/atoms/ProgressScreen';
import Emoji from 'presentations/views/components/atoms/Emoji';
import Tooltip from 'presentations/views/components/atoms/Tooltip';

interface Props {
  userId?: string;
  projectId?: string;
  name: string | null;
  profileImage?: string | null;
  icon?: string | null;
  color?: string | null;
  isActive: boolean;
  isLoading?: boolean;
  onClick: (e: SyntheticEvent<HTMLDivElement>) => void;
  margin?: number;
}

const Component = (props: Props) => {
  const renderMember = (props: Props) => {
    const name = props.name ? props.name.substring(0, 1) : '';
    if (props.icon) {
      return (
        <Tooltip title={props.name}>
          <ProjectIcon name={props.icon || 'flag'} size={24} />
        </Tooltip>
      );
    }
    const imageUrl = props.profileImage
      ? transformImageUrl(props.profileImage, {
          width: 48,
          height: 48,
        })
      : null;
    return (
      <Tooltip title={props.name}>
        <MenuAvatar src={imageUrl} color={props.color}>
          {name}
        </MenuAvatar>
      </Tooltip>
    );
  };

  return (
    <>
      <UserContainer
        data-id={props.userId}
        data-project-id={props.projectId}
        margin={props.margin}
        onClick={props.onClick}
      >
        {props.isActive ? (
          <ActiveBorder>{renderMember(props)}</ActiveBorder>
        ) : (
          <Border>{renderMember(props)}</Border>
        )}
        <Name>{props.name}</Name>
      </UserContainer>
      {props.isLoading && <ProgressScreen isOpen />}
    </>
  );
};

export const UserContainer = styled.div<{ margin?: number }>`
  cursor: pointer;
  height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: ${(props) =>
    props.margin ? `${props.margin}px` : spacing(16)};
  align-items: center;
`;
const Name = styled.div`
  width: 48px;
  overflow: hidden;
  /* text-overflow: ellipsis; */
  white-space: nowrap;
  font-size: ${fontSize(10)};
  color: ${gray02};
  text-align: center;
  padding: 0 4px;
  letter-spacing: 0.04em;
  font-weight: ${fontWeight('bold')};
`;
export const ActiveBorder = styled.div`
  border: 2px solid ${primary};
  display: flex;
  /* flex: 1; */
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 50%;
  width: 48px;
  height: 48px;
`;
export const Border = styled.div`
  border: 4px solid ${blueGrayPale};
  display: flex;
  /* flex: 1; */
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 50%;
  width: 48px;
  height: 48px;
`;
export const MenuAvatar = styled(Avatar)<{
  color?: string | null;
}>`
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.color};
  font-weight: ${fontWeight('bold')};
`;

const ProjectIcon = styled(Emoji)`
  display: flex;
`;
export default Component;
